// configureStore.js
// Redux Store configuration file

// Imports
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from '../reducers/';

// Configures the Redux Store
function configureStore (preloadedState) {
  return createStore(
    rootReducer,
    preloadedState,
    applyMiddleware(thunk),
  )
}

// Default Export
export default configureStore;


// WEBPACK FOOTER //
// ./src/config/configureStore.js